// extracted by mini-css-extract-plugin
var _1 = "ApplicantDecisionUser-moduleApplicantDecisionUser__bacI5";
var _2 = "ApplicantDecisionUser-modulemuted__jxuKg";
export { _1 as "ApplicantDecisionUser", _2 as "muted" }
